import { ResourceType } from "components/Resources/ResourceList";
import { DocumentType, DocumentUploadType } from "./types";

export const documentTypes: DocumentUploadType[] = [
  {
    type: DocumentType.DEBT_CONSOLIDATION_FORM,
    label: "Debt Consolidation Form*",
    description:
      "Form to be completed listing the customer's debts to be consolidated.",
    maxFiles: 1,
  },
];

export const linkDocumentTypes: ResourceType[] = [];
